import { STREAM_CARET_CLASS } from '../../../../lib/rehype-streaming-caret';

// Magenta-pink dot (M42 hydrogen-alpha color) marking the active speaking moment
// — shown only on a still-typing bubble.
//
// Used by the two PLAIN-TEXT bubbles (a voice transcript, a contact-mention body), where the text is
// inline inside one block span, so this element lands on the same line as the text and costs no height.
// The markdown bubble does NOT use it: there the caret is placed on the hast tree, because an element
// after `Markdown`'s block-level wrapper opens a line box of its own — see `lib/rehype-streaming-caret`.
//
// The paint itself lives on `.sym-stream-caret` in `styles/globals.css`, shared with the markdown
// caret so the two can never drift apart.
export function StreamingCursor() {
  return <span aria-hidden className={STREAM_CARET_CLASS} />;
}
